import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTableStatic from 'components/organisms/data-table-static'
import CmsFeaturedSellerLandingPageRelatedArticleTableColumns from 'domains/cms-featured-seller/molecules/landing-page-related-article-table-column'

const propTypes = {
  data           : PropTypes.array,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    onButtonClick    : PropTypes.func,
    isButtonDisabled : PropTypes.bool
  })
}

const defaultProps = {
  data           : [],
  hiddenColumns  : [],
  rowButtonProps : {
    buttonText       : 'Remove',
    buttonColour     : 'danger',
    onButtonClick    : () => { alert('button clicked') },
    isButtonDisabled : false
  }
}

/**
 * Table to display Related Articles landing page section
 * @param {Array<Object>} data - array of related article objects
 * @param {hiddenColumns} hiddenColumns - columns that hidden intentionally
 * @param {Object} rowButtonProps - props of rowButton
 */
const CmsFeaturedSellerLandingPageRelatedArticleTable = ({
  data,
  hiddenColumns,
  rowButtonProps
}) => {

  const { buttonText, buttonColour, onButtonClick, isButtonDisabled } = rowButtonProps

  const columns = useMemo(
    () => CmsFeaturedSellerLandingPageRelatedArticleTableColumns({
      buttonText,
      buttonColour,
      onButtonClick,
      isButtonDisabled
    }),
    [
      buttonColour,
      buttonText,
      onButtonClick,
      isButtonDisabled
    ]
  )

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
      hiddenColumns={ hiddenColumns }
      showPagination={ false }
      defaultPageSize={ 20 }
    />
  )
}

CmsFeaturedSellerLandingPageRelatedArticleTable.propTypes    = propTypes
CmsFeaturedSellerLandingPageRelatedArticleTable.defaultProps = defaultProps

export default CmsFeaturedSellerLandingPageRelatedArticleTable
